import getRoleProperty from '../getRoleProperty';
import _ from 'lodash';

class ContactRoleAdditionalInterest {
    constructor() {
        this.$onInit = () => {
            if (this.roleType === 'account') this.accountLevel = true;

            const {fieldGetter} = getRoleProperty(this.roleType, this.roleModel, 'additionalInterest', 'policyAdditionalInterest');
            const details = fieldGetter(undefined, 'additionalInterestDetails.children') || [];

            this.additionalInterestDetails = details.map(detail => {
                return {
                    subtype: _.get(detail, 'subtype.value.name'),
                    type: _.get(detail, 'type.value.name'),
                    certificateRequired: _.get(detail, 'certificateRequired.value'),
                    contractNumber: _.get(detail, 'contractNumber.value'),
                    interest: _.get(detail, 'interest.value')
                };
            });
        };
    }
}

export default ContactRoleAdditionalInterest;
